<template lang="pug">
  b-modal#bot(
    ref="bot"
    :title='$t("ui.moreinfo")'
    centered
    no-fade
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown")

    template(v-if="selectedBot")
      table.table.mb-1
        thead
          tr
            th(colspan="2")
              span  {{ $t("ui.robot") }}
        tbody
          tr
            td(style="width: 100px;")
              span {{ $t("ui.id") }}
            td
              span.font-weight-bold.text-secondary {{ this.selectedBot.bot.id }}
          tr
            td(style="width: 100px;")
              span {{ $t("ui.model") }}
            td
              span.font-weight-bold.text-secondary {{ this.selectedBot.bot.model }}
          tr
            td
              span {{ $t("ui.version") }}
            td
              span {{ this.selectedBot.bot.version }}
          tr
            td
              span {{ $t("ui.hostname") }}
            td
              span {{ this.selectedBot.bot.hostname }}
          tr
            td
              span {{ $t("ui.ipaddress") }}
            td
              span {{ this.selectedBot.bot.ip_address }}

      table.table.mb-1(v-if="this.selectedBot.system")
        thead
          tr
            th(colspan="2")
              span {{ $t("ui.system") }}
        tbody
          tr
            td(style="width: 100px;")
              span {{ $t("ui.machine") }}
            td
              span {{ this.selectedBot.system.machine }}
          tr
            td
              span {{ $t("ui.version") }}
            td
              span {{ this.selectedBot.system.version }}
          tr
            td
              span {{ $t("ui.platform") }}
            td
              span {{ this.selectedBot.system.platform }}
          tr
            td
              span {{ $t("ui.cpupercentage") }}
            td
              span {{ this.selectedBot.system.cpu_percent }}
          tr
            td
              span {{ $t("ui.virtualmemory") }}
            td
              span {{ this.selectedBot.system.virtual_memory }}
          tr
            td
              span {{ $t("ui.runtime") }}
            td
              span {{ this.selectedBot.system.run_time }}

      table.table.mb-1
        thead
          tr
            th(colspan="2")
              span {{ $t("ui.target") }}
        tbody
          tr
            td(style="width: 100px;")
              span {{ $t("ui.providerid") }}
            td
              span.font-weight-bold.text-warning {{ this.selectedBot.target.provider_id }}
          tr
            td
              span {{ $t("ui.fullname") }}
            td
              span.font-weight-bold.text-info {{ this.selectedBot.target.login_id }}
          tr
            td
              span {{ $tc("ui.hosts", 2) }}
            td
              span {{ this.selectedBot.target.host }}
          tr
            td
              span {{ $t("ui.username") }}
            td
              span {{ this.selectedBot.target.username }}
          tr
            td
              span {{ $t("ui.password") }}
            td
              span {{ this.selectedBot.target.password }}

      table.table.mb-1
        thead
          tr
            th(colspan="2")
              span {{ $t("ui.payload") }}
        tbody
          tr
            td
              span {{ $t("ui.created_on") }}
            td
              span {{ this.selectedBot.date_time }}
          tr
            td(style="width: 100px;")
              span {{ $t("ui.action") }}
            td
              span.font-weight-bold.text-primary.text-uppercase {{ this.selectedBot.payload.action }}
          tr
            td
              span {{ $t("ui.result") }}
            td
              span.font-weight-bold(:class="{ 'text-success' : this.selectedBot.payload.success,  'text-danger' : !this.selectedBot.payload.success }") {{ this.selectedBot.payload.result }}
          tr
            td(colspan="2")
              div.font-weight-bold.text-danger(style="font-size: 10px; white-space: normal; width: 100%;") {{ this.selectedBot.payload.exception }}
      div(slot="modal-footer")
        SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="getMoreInfo()" size="sm")
</template>

<script>
import { required, minLength, maxLength, url } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import _ from "lodash";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    selectedBot:{
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: "",
        host_url: ""
      }
    };
  },
  computed: {

  },
  validations: {
  },
  watch: {
  },
  mounted: function() {
  },
  methods: {
    test: function(event) {
      alert("123" + event);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
    },
    getMoreInfo: function() {
      this.$refs.bot.hide();
    },
  }
};
</script>
